export type SavedTallyKey = {
  platformProductId: string;
  cannedTallyId: string | null;
};

type TallyPick =
  | { kind: 'length' }
  | { kind: 'lengths' }
  | { kind: 'canned'; cannedTally: { id: string } }
  | { kind: 'random'; platformProduct: { id: string } };

export function findSavedTally<Saved>(
  savedTallies: readonly Saved[],
  tallyKeyOf: (saved: Saved) => SavedTallyKey | null,
  pick: TallyPick
): Saved | undefined {
  if (pick.kind === 'length' || pick.kind === 'lengths') return undefined;
  return savedTallies.find((saved) => {
    const key = tallyKeyOf(saved);
    if (!key) return false;
    return pick.kind === 'canned'
      ? key.cannedTallyId === pick.cannedTally.id
      : key.cannedTallyId === null &&
          key.platformProductId === pick.platformProduct.id;
  });
}

export function findSavedCannedTallyOfProduct<Saved>(
  savedTallies: readonly Saved[],
  tallyKeyOf: (saved: Saved) => SavedTallyKey | null,
  platformProductId: string
): Saved | undefined {
  return savedTallies.find((saved) => {
    const key = tallyKeyOf(saved);
    return (
      !!key &&
      key.cannedTallyId !== null &&
      key.platformProductId === platformProductId
    );
  });
}
